"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Item = require("./Item");
require("./List.scss");
var List = function List(_ref) {
  var className = _ref.className,
    links = _ref.links;
  var Item = List.Item;
  var rootClassName = (0, _classnames["default"])('cds-Dropdown-List', className);
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: rootClassName
  }, links.map(function (link, index) {
    return /*#__PURE__*/_react["default"].createElement(Item, {
      link: link,
      key: (0, _key.createKey)(link.title || 'Item', index)
    });
  }));
};
exports.List = List;
List.Item = _Item.Item;